module.exports = __webpack_public_path__ + "media/images/user-guide-2-747c52171d6279970fade5120d42df34.png";